module.exports = __webpack_public_path__ + "img/TZS09608.0ddf98dc.jpeg";